/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Instruction intent
 */
export type InstructionCancelRequestIntent = typeof InstructionCancelRequestIntent[keyof typeof InstructionCancelRequestIntent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstructionCancelRequestIntent = {
  TRANSFER: 'TRANSFER',
  CARD_PAYMENT: 'CARD_PAYMENT',
  FEE: 'FEE',
  PAYMENT: 'PAYMENT',
  EXCHANGE: 'EXCHANGE',
  INSURANCE: 'INSURANCE',
  FOREX: 'FOREX',
  COMMODITIES: 'COMMODITIES',
  OTHER: 'OTHER',
  CHARGE: 'CHARGE',
  ADJUSTMENT: 'ADJUSTMENT',
  DIGITAL_DEPOSIT: 'DIGITAL_DEPOSIT',
  DIGITAL_WITHDRAWAL: 'DIGITAL_WITHDRAWAL',
  SECURITIES_TRANSFER: 'SECURITIES_TRANSFER',
  SECURITIES_APPLICATION: 'SECURITIES_APPLICATION',
  EXCHANGE_SUB_ACCOUNT_APPLICATION: 'EXCHANGE_SUB_ACCOUNT_APPLICATION',
  EXCHANGE_SUB_ACCOUNT_TRANSFER: 'EXCHANGE_SUB_ACCOUNT_TRANSFER',
  EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE: 'EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE',
  CARD_APPLICATION: 'CARD_APPLICATION',
  ASSET_INJECTION: 'ASSET_INJECTION',
  ASSET_WITHDRAWAL: 'ASSET_WITHDRAWAL',
  BILL_PAYMENT: 'BILL_PAYMENT',
  COMMISSION: 'COMMISSION',
  SETTLEMENT: 'SETTLEMENT',
  FUND_DISTRIBUTION: 'FUND_DISTRIBUTION',
  REMITTANCE: 'REMITTANCE',
  GENERAL_INSTRUCTION: 'GENERAL_INSTRUCTION',
  EARN_SUBSCRIPTION: 'EARN_SUBSCRIPTION',
  EARN_REDEMPTION: 'EARN_REDEMPTION',
} as const;
